import React from 'react';
import { useTranslation } from 'react-i18next';
import { setAppLanguage } from '../i18n';

export const LanguageToggle: React.FC<{ className?: string }> = ({ className = '' }) => {
  const { t, i18n } = useTranslation();
  const lng = i18n.language?.startsWith('es') ? 'es' : 'en';

  return (
    <div
      className={`flex h-11 min-h-[44px] overflow-hidden rounded-dg-control border border-dg-border bg-dg-bg-muted shadow-dg-card dark:border-slate-600 dark:bg-slate-900/80 ${className}`}
      role="group"
      aria-label={t('common.language')}
    >
      <button
        type="button"
        onClick={() => setAppLanguage('en')}
        aria-pressed={lng === 'en'}
        title={t('common.english')}
        className={`min-w-[2.75rem] px-2.5 text-dg-label font-semibold uppercase tracking-wide transition-colors ${
          lng === 'en'
            ? 'bg-dg-bg-surface text-dg-fg-primary dark:bg-slate-800 dark:text-slate-50'
            : 'text-dg-fg-muted hover:bg-dg-interaction-hover dark:text-slate-300 dark:hover:bg-slate-800'
        }`}
      >
        EN
      </button>
      <button
        type="button"
        onClick={() => setAppLanguage('es')}
        aria-pressed={lng === 'es'}
        title={t('common.spanish')}
        className={`min-w-[2.75rem] px-2.5 text-dg-label font-semibold uppercase tracking-wide transition-colors ${
          lng === 'es'
            ? 'bg-dg-bg-surface text-dg-fg-primary dark:bg-slate-800 dark:text-slate-50'
            : 'text-dg-fg-muted hover:bg-dg-interaction-hover dark:text-slate-300 dark:hover:bg-slate-800'
        }`}
      >
        ES
      </button>
    </div>
  );
};
